import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { ArgovLogo } from "@/components/ArgovLogo";
import { useAuth } from "@/lib/auth";
import { LOGIN } from "@/constants/testIds";
import { formatApiError } from "@/lib/api";

export default function LoginPage() {
  const { user, login, initialized } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (initialized && user && user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (err) {
      const status = err?.response?.status;
      if (status === 429) setError("Too many failed attempts. Please try again later.");
      else setError(formatApiError(err?.response?.data?.detail) || "Login failed. Check your credentials.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#0c1a2e", color: "#fff", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 40 }}>
      <Link to="/" style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 32 }}>
        <ArgovLogo size={40} />
        <span style={{ fontSize: 20, fontWeight: 800, color: "#fff", letterSpacing: "-0.02em" }}>ARGOV<span style={{ color: "#0891b2", fontWeight: 500 }}>™</span></span>
      </Link>
      <div style={{ width: "100%", maxWidth: 420, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 16, padding: 32, backdropFilter: "blur(6px)" }}>
        <p className="font-mono" style={{ fontSize: 11, color: "#0891b2", letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 10 }}>CLIENT LOGIN</p>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: "#fff", marginBottom: 8, letterSpacing: "-0.02em" }}>Sign in to ARGOV CRM</h1>
        <p style={{ fontSize: 13.5, color: "#8fa3c8", marginBottom: 24 }}>Governance operator access. All authentication attempts are logged.</p>

        <form onSubmit={onSubmit} data-testid={LOGIN.form} style={{ display: "flex", flexDirection: "column", gap: 16 }} noValidate>
          <div>
            <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#8fa3c8", marginBottom: 6, letterSpacing: "0.02em" }}>Email</label>
            <input data-testid={LOGIN.email} type="email" required autoComplete="username" placeholder="admin@argov.ai" value={email} onChange={(e) => setEmail(e.target.value)}
              style={{ width: "100%", padding: "11px 14px", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.14)", borderRadius: 8, color: "#fff", fontSize: 14, outline: "none", fontFamily: "'DM Sans',sans-serif" }} />
          </div>
          <div>
            <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#8fa3c8", marginBottom: 6, letterSpacing: "0.02em" }}>Password</label>
            <input data-testid={LOGIN.password} type="password" required autoComplete="current-password" placeholder="••••••••••" value={password} onChange={(e) => setPassword(e.target.value)}
              style={{ width: "100%", padding: "11px 14px", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.14)", borderRadius: 8, color: "#fff", fontSize: 14, outline: "none", fontFamily: "'DM Sans',sans-serif" }} />
          </div>
          {error && (
            <p data-testid={LOGIN.error} style={{ fontSize: 13, color: "#fca5a5", background: "rgba(220,38,38,0.1)", border: "1px solid rgba(220,38,38,0.3)", borderRadius: 8, padding: "9px 12px" }}>{error}</p>
          )}
          <button data-testid={LOGIN.submit} disabled={busy} type="submit"
            style={{ width: "100%", padding: 12, background: busy ? "#0e7490" : "#0891b2", color: "#fff", border: "none", borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: busy ? "wait" : "pointer", fontFamily: "'DM Sans',sans-serif" }}>
            {busy ? "Signing in..." : "Sign in →"}
          </button>
        </form>

        <p style={{ marginTop: 20, fontSize: 12, color: "#4a6080", textAlign: "center" }}>
          <Link to="/" style={{ color: "#0891b2" }}>← Back to argov.ai</Link>
        </p>
      </div>
    </div>
  );
}
